// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"56":"3350dbc8","340":"4d4918b7"}[chunkId] + ".js";
};